import { IGetState } from '../../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { showSnoozeBlocker } from '../../../../../../../base/effects/showSnoozeBlocker';

export const onDisallowClick = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(showSnoozeBlocker({
            allow: 'allowRequiredProperties'
        }));
    };
    return action;
};
